import { Button, Modal } from "@mantine/core";
import type React from "react";
import type { ClientTrainingRequest } from "../../../types/portal";

interface CancelRequestModalProps {
  opened: boolean;
  request: ClientTrainingRequest | null;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const CancelRequestModal: React.FC<CancelRequestModalProps> = ({
  opened,
  request,
  loading,
  onCancel,
  onConfirm,
}) => (
  <Modal
    opened={opened}
    onClose={onCancel}
    title=""
    withCloseButton={false}
    size="md"
    classNames={{
      content: "rounded-2xl overflow-hidden p-0",
      body: "p-0",
    }}
  >
    <div className="bg-primary text-primary-foreground py-4 sm:py-5 px-4 sm:px-6 text-center">
      <h3 className="m-0 text-lg sm:text-xl font-semibold">Cancel Training Request</h3>
    </div>
    <div className="p-4 sm:p-6">
      <p className="text-[1.1rem] text-foreground mb-5 text-center leading-relaxed">
        Are you sure you want to cancel your training request with{" "}
        <strong>{request?.trainer_name}</strong>?
      </p>
      <div className="bg-muted rounded-lg p-4 mb-5">
        <div className="flex justify-between items-center mb-2">
          <span className="text-[0.9rem] text-muted-foreground font-medium">Trainer:</span>
          <span className="text-[0.9rem] text-foreground font-semibold">{request?.trainer_name}</span>
        </div>
        <div className="flex justify-between items-center mb-2">
          <span className="text-[0.9rem] text-muted-foreground font-medium">Status:</span>
          <span className="text-[0.9rem] text-foreground font-semibold">{request?.status}</span>
        </div>
        <div className="flex justify-between items-center mb-2">
          <span className="text-[0.9rem] text-muted-foreground font-medium">Requested:</span>
          <span className="text-[0.9rem] text-foreground font-semibold">
            {request?.created_at ? new Date(request.created_at).toLocaleString() : "N/A"}
          </span>
        </div>
      </div>
      <div className="bg-warning/10 border border-warning/25 rounded-lg p-3 mt-4 text-[0.9rem] text-warning text-center">
        This action cannot be undone. You will need to create a new request if you want to train
        with this trainer again.
      </div>
    </div>
    <div className="flex flex-wrap gap-3 justify-end px-4 sm:px-6 pb-4 sm:pb-6">
      <Button variant="default" className="min-w-[100px]" onClick={onCancel} disabled={loading}>
        No, Keep Request
      </Button>
      <Button
        color="green"
        radius="md"
        className="min-w-[140px]"
        onClick={onConfirm}
        disabled={loading}
      >
        {loading ? "Cancelling..." : "Yes, Cancel Request"}
      </Button>
    </div>
  </Modal>
);

export default CancelRequestModal;
